import { useContext } from 'react';
import ThemeContext from '../contexts/ThemeContext';
export const useTheme = (context = ThemeContext) => useContext(context);
export default useTheme;
